import { FC } from 'react'
import { Box, styled, BoxProps } from '@mui/material'
import { Loader } from '@icanbwell/ui-toolkit'

const ProgressContainer = styled(Box)({
  height: '100vh',
  width: '100vw',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const LoadingScreen: FC<BoxProps> = (props) => (
  <ProgressContainer {...props}>
    <Loader  />
  </ProgressContainer>
)

export default LoadingScreen
